import { useState } from 'react';
import { MIN_SWIPE_DISTANCE } from '../../../../constants/Constants';

interface useDesktopSwipeProps {
  setTouchPosition: (position: number) => void;
  touchPosition: number;
  nextSlide: () => void;
  prevSlide: () => void;
}

export const useDesktopSwipe = ({ setTouchPosition, touchPosition, nextSlide, prevSlide }: useDesktopSwipeProps) => {
  // position of the touch start
  const [startPosition, setStartPosition] = useState(0);
  // true if the user is dragging
  const [isDragging, setIsDragging] = useState(false);

  // function to handle mouse down
  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    setStartPosition(e.clientX);
    setIsDragging(true);
  };

  // set the touch position and calculate the distance when the user is dragging
  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging) return;
    e.preventDefault();
    setTouchPosition(e.clientX - startPosition);
  };

  // handle mouse up
  const handleMouseUp = () => {
    if (touchPosition > MIN_SWIPE_DISTANCE) {
      // Swipe Left, show next
      prevSlide();
    } else if (touchPosition < -MIN_SWIPE_DISTANCE) {
      // Swipe Right, show previous
      nextSlide();
    }
    setIsDragging(false);
    setTouchPosition(0);
  };

  // end the swipe action when the cursor leaves the element
  const onMouseLeave = () => {
    if (!isDragging) return;
    handleMouseUp();
  };

  return {
    handleMouseDown,
    handleMouseMove,
    handleMouseUp,
    onMouseLeave,
    isDragging,
  };
};
